"use strict";

(() => {
  function getScrollAmount(viewport, track) {
    const firstSlide = track.querySelector(".age-section__slide");

    if (!firstSlide) {
      return viewport.clientWidth;
    }

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;

    return firstSlide.getBoundingClientRect().width + gap;
  }

  function getVisibleSlidesCount() {
    if (window.matchMedia("(max-width: 479.98px)").matches) {
      return 2.5;
    }

    if (window.matchMedia("(max-width: 767.98px)").matches) {
      return 3;
    }

    if (window.matchMedia("(max-width: 991.98px)").matches) {
      return 3.5;
    }

    return 6;
  }

  function getSlideWidthValue(viewportWidth, gap) {
    const visibleSlides = getVisibleSlidesCount();

    if (visibleSlides === 1) {
      return `${viewportWidth * 0.78}px`;
    }

    return `${(viewportWidth - gap * (visibleSlides - 1)) / visibleSlides}px`;
  }

  function applyResponsiveSlidesWidth(viewport, track) {
    const slides = track.querySelectorAll(".age-section__slide");

    if (!slides.length) {
      return;
    }

    const viewportWidth = viewport.clientWidth;

    if (!viewportWidth) {
      return;
    }

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
    const slideWidth = getSlideWidthValue(viewportWidth, gap);

    slides.forEach((slide) => {
      slide.style.flex = `0 0 ${slideWidth}`;
      slide.style.maxWidth = slideWidth;
    });
  }

  function updateSliderNavigation(section) {
    const viewport = section.querySelector("[data-age-viewport]");
    const prevButton = section.querySelector("[data-age-prev]");
    const nextButton = section.querySelector("[data-age-next]");

    if (!viewport || !prevButton || !nextButton) {
      return;
    }

    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    const currentScrollLeft = viewport.scrollLeft;

    prevButton.disabled = currentScrollLeft <= 1;
    nextButton.disabled = currentScrollLeft >= maxScrollLeft - 1;
  }

  function initAgeSection(section) {
    const viewport = section.querySelector("[data-age-viewport]");
    const track = section.querySelector("[data-age-track]");

    if (section.dataset.ageSectionInitialized === "true") {
      if (viewport && track) {
        applyResponsiveSlidesWidth(viewport, track);
      }

      updateSliderNavigation(section);
      return;
    }

    const prevButton = section.querySelector("[data-age-prev]");
    const nextButton = section.querySelector("[data-age-next]");
    let resizeFrame = null;

    if (!viewport || !track || !prevButton || !nextButton) {
      return;
    }

    const syncSliderLayout = () => {
      applyResponsiveSlidesWidth(viewport, track);
      updateSliderNavigation(section);
    };

    prevButton.addEventListener("click", () => {
      viewport.scrollBy({
        left: getScrollAmount(viewport, track) * -1,
        behavior: "smooth",
      });
    });

    nextButton.addEventListener("click", () => {
      viewport.scrollBy({
        left: getScrollAmount(viewport, track),
        behavior: "smooth",
      });
    });

    viewport.addEventListener("scroll", () => {
      window.requestAnimationFrame(() => {
        updateSliderNavigation(section);
      });
    });

    window.addEventListener("resize", () => {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        syncSliderLayout();
      });
    });

    section.dataset.ageSectionInitialized = "true";

    syncSliderLayout();
  }

  function initAgeSections(scope = document) {
    const sections = scope.querySelectorAll("[data-age-section]");

    sections.forEach((section) => {
      initAgeSection(section);
    });
  }

  window.ageSectionSliderUi = {
    init: initAgeSections,
  };

  document.addEventListener("DOMContentLoaded", () => {
    initAgeSections();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initAgeSections(event.target);
  });
})();
